import type React from 'react';
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import './style.m.less';

const MODES = {
    CROSS: 'cross',
    CROSS_WAIT: 'wait',
    RIGHT_OUT: 'right-out',
    GENTLE_LEFT: 'gentle-left',
    GENTLE_RIGHT: 'gentle-right',
    GENTLE_TOP: 'gentle-top',
    GENTLE_BOTTOM: 'gentle-bottom',
} as const;

const TIMEOUT = 600;
const WAIT_TIMEOUT = 1200;

const NAMES = {
    [MODES.CROSS]: 'react-crossfade',
    [MODES.CROSS_WAIT]: 'react-crossfade-wait',
    [MODES.RIGHT_OUT]: 'react-crossfade-right-out',
    [MODES.GENTLE_LEFT]: 'react-crossfade-gentle-left',
    [MODES.GENTLE_RIGHT]: 'react-crossfade-gentle-right',
    [MODES.GENTLE_TOP]: 'react-crossfade-gentle-top',
    [MODES.GENTLE_BOTTOM]: 'react-crossfade-gentle-bottom',
};

function needsToWait(mode: Mode) {
    return mode !== MODES.CROSS;
}

type Mode = (typeof MODES)[keyof typeof MODES];

type Props = {
    children?: React.ReactElement | null;
    mode?: Mode;
};

export default function Crossfade({ children, mode = MODES.CROSS }: Props) {
    const props = {
        transitionName: NAMES[mode],
        transitionEnterTimeout: TIMEOUT,
        transitionLeaveTimeout: needsToWait(mode) ? WAIT_TIMEOUT : TIMEOUT,
    };

    return (
        <ReactCSSTransitionReplace {...props}>
            {children && <div key={children.key}>{children}</div>}
        </ReactCSSTransitionReplace>
    );
}

Crossfade.MODES = MODES;
